<template>
    <div>
        <div v-show="loader" class="text-only"> 
            <v-progress-circular
            indeterminate
            color="white"
            ></v-progress-circular>
        </div>
        <div v-show="!loader && chartData.length>0">
            <!-- <v-row>
                <v-col>
                    <div class="text-center">
                        <v-chip
                        class="ma-2"
                        color="indigo"
                        text-color="white"
                        >
                        <v-avatar left>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-avatar>
                        Ranee
                        </v-chip>

                        <v-chip
                        class="ma-2"
                        color="orange"
                        text-color="white"
                        >
                        Premium
                        <v-icon right>mdi-star</v-icon>
                        </v-chip>

                        <v-chip
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        >
                        1 Year
                        <v-icon right>mdi-cake-variant</v-icon>
                        </v-chip>

                        <v-chip
                        class="ma-2"
                        color="green"
                        text-color="white"
                        >
                        <v-avatar
                            left
                            class="green darken-4"
                        >
                            1
                        </v-avatar>
                        Years
                        </v-chip>

                        <v-chip
                        class="ma-2"
                        close
                        color="teal"
                        text-color="white"
                        >
                        <v-avatar left>
                            <v-icon>mdi-checkbox-marked-circle</v-icon>
                        </v-avatar>
                        Confirmed
                        </v-chip>

                        <v-chip
                        class="ma-2"
                        close
                        color="teal"
                        text-color="white"
                        close-icon="mdi-delete"
                        >
                        <v-avatar left>
                            <v-icon>mdi-checkbox-marked-circle</v-icon>
                        </v-avatar>
                        Confirmed
                        </v-chip>
                    </div>
                </v-col>
            </v-row> -->
            <v-tabs
                color="accent-4"
                right
            >
                <v-tab class="tab"> 
                    <v-icon dark>mdi-chart-areaspline</v-icon>
                </v-tab>
                <v-tab class="tab">
                    <v-icon dark>mdi-table</v-icon>
                </v-tab>

                <v-tab-item eager>
                    <v-container fluid>
                        <div 
                            class="chart-div" 
                            ref="chartdiv"
                        >
                        </div>
                    </v-container>
                </v-tab-item>
                <v-tab-item>
                    Sellers Count: {{ sellersLength }}
                    <v-container fluid v-for="data in rawData" :key="data.seller.id">
                        <h2 class="heading">
                            <a :href="sellerLink(data.seller.id)" target="_blank" class="seller-link">
                                Seller name: {{ data.seller.name }}
                            </a>
                        </h2><br>
                        <v-data-table
                        :headers="headers"
                        :items="data.tracks"
                        :items-per-page="20"
                        >
                            <template v-slot:[`item.created_at`]="{ item }" >
                                <p> {{ item.created_at | formatDate }} </p>
                            </template>
                            <template v-slot:[`item.buy_box`]="{ item }" >
                                <v-chip v-if="item.buy_box" filter color="red">Buy box</v-chip>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-tab-item>
            </v-tabs>
        </div>
        <div v-show="!loader && chartData.length === 0" class="text-only"> No data :( </div>
    </div>
</template>

<script>

/* Amchart includes */

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment'

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);

export default {
    name: 'ProductSalles',
    props :[
        'productId',
        'selectedProduct'
    ],
    data : () => ({
        chart: null,
        headers: [
          { text: 'Seller count', value: 'nbr_seller' },
          { text: 'Date tracking', value: 'created_at' },
          { text: 'Buy box', value: 'buy_box' },
          { text: 'FBA', value: 'fba' },
          { text: 'Seller ratings', value: 'star_count' },
          { text: 'Rating', value: 'rating_count' },
          { text: 'Price', value: 'price' },
          { text: 'Quantity', value: 'quantity' },
          { text: 'Shipping price', value: 'shipping_price' }
        ],
        rawData:[],
        sellerNameOnChart: "",
        loader: true
    }),
    methods: {
        createChart () {
            am4core.options.responsive = true;
            am4core.options.maintainAspectRatio = true;

            let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

            /* Chart code */

            // Create axes            
            let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            // dateAxis.renderer.grid.template.location = 0;
            dateAxis.renderer.minGridDistance = 40;
            // dateAxis.tooltip.disabled = true;
            dateAxis.title.text = this.sellerNameOnChart;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            }

            let valueAxisY = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxisY.title.text = 'Quantity';
            // valueAxisY.logarithmic = true;
            // valueAxisY.renderer.minGridDistance = 20;

            // Create series
            let series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = "seller1";
            series.dataFields.dateX = "date";
            series.tensionX = 0.8;
            series.strokeWidth = 2;
            series.stacked = true;
            series.fillOpacity = 0.2;
            series.tooltipText = "{dateX} : [bold]{valueY}[/]";

            let bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.fill = am4core.color("white");
            bullet.circle.strokeWidth = 5;

            /* Add legend */
            // chart.legend = new am4charts.Legend();

            // Add cursor
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.fullWidthLineX = true;
            // chart.cursor.xAxis = dateAxis;
            chart.cursor.lineX.strokeWidth = 5;
            chart.cursor.lineX.fill = am4core.color("#000");
            chart.cursor.lineX.fillOpacity = 0.4;

            // Add scrollbar
            var scrollbar = new am4charts.XYChartScrollbar();
            scrollbar.series.push(series)
            chart.scrollbarX = scrollbar;
            // chart.scrollbarX.showSystemTooltip = true;
            // chart.scrollbarX.thumb.showSystemTooltip = true;
            // chart.scrollbarX.startGrip.showSystemTooltip = true;
            // chart.scrollbarX.endGrip.showSystemTooltip = true;

            // chart.scrollbarX = new am4core.Scrollbar();

            // Add a guide
            // let range = valueAxis.axisRanges.create();
            // range.value = 90.4;
            // range.grid.stroke = am4core.color("#396478");
            // range.grid.strokeWidth = 1;
            // range.grid.strokeOpacity = 1;
            // range.grid.strokeDasharray = "3,3";
            // range.label.inside = true;
            // range.label.text = "Average";
            // range.label.fill = range.grid.stroke;
            // range.label.verticalCenter = "bottom";

            chart.data = this.chartData;
            this.chart = chart;
        },
        processData (data){
            if(data && data.length>0){
                // Fill table
                this.rawData = data;

                this.sellerNameOnChart = data[0].seller.name;
                console.log(data[0].seller.name);
                // Fill chart
                var sales = data[0].tracks;
                return sales.map( (rawData)=>{
                    //, index, source
                    let item = { 
                        date: new Date(moment(String(rawData.created_at)).format('yyyy-MM-DD HH:mm:ss')),
                        seller1: rawData.quantity,
                    }
                    console.log({item});
                    return item;
                });
            }else{
                this.rawData = [];
                this.sellerNameOnChart = "";
                return [];
            }
        },
        loadData () {
            
            if(this.productId){
                // Get history
                this.$store.dispatch('GET_PRODUCT_HISTORY', this.productId);
            }else{
                // TODO show message No id
            }
        },
        emptyModal () {
            this.loader = true;
            this.chartData = [];
            this.rawData = [];
        },
        sellerLink ( seller_id ){
            return  seller_id ? 'https://amazon.'+ this.selectedProduct.country +'/dp/'+ this.selectedProduct.asin +'/?m=' + seller_id:'#';
        }
    },
    mounted() {
        this.loader = true;
        window.console.log('modal Mounted');
        window.console.log(this.rawData);
        window.console.log(this.chartData);
        // Remove product history
        this.$store.dispatch('EMPTY_PRODUCT_HISTORY');

        // Create chart
        this.createChart();

        //Load data for the first time
        this.loadData();
        window.console.log(this.rawData);
        window.console.log(this.chartData);
    },
    computed: {
        chartData:{
            get () {
                return this.processData( this.$store.getters.getProductHistory );
            },
            set (data) {
                this.chartData = data;
            }
        },
        sellersLength(){
            return this.rawData.length;
        }
    },
    watch: {
        productId: function () {
            this.loader = true;
            this.loadData();
        },
        chartData: function () {
            this.loader = false;
            // Update chart 
            if(this.chartData.length>0){
                this.chart.data = this.chartData;
            }
        }
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    }
};
</script>

<style scoped>
    .chart-div{
        width: 100%;
        height: 350px !important;
    }
    .card{
        margin-top: 12px;
    }
    .loader{
        text-align: center;
    }
    .chart-card-title{
        display: flex;
    }
    .text-only{
        height: 422px;
        line-height: 422px;
        text-align: center;
        font-size: 22px;
        font-weight: bold;
    }
    .tab{
        min-width: 20px;
        padding: 10px;
    }
    .seller-link{
        color: white;
        text-decoration: none;
    }
</style>
